export default "__VITE_ASSET__BZuBgKQt__"